import React from 'react';
import { TextField } from '@mui/material';

interface LevelNumberFieldProps {
  value: number;
  onChange: (value: number) => void;
  disabled?: boolean;
}

export const LevelNumberField: React.FC<LevelNumberFieldProps> = ({
  value,
  onChange,
  disabled = false,
}) => {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = Number(e.target.value);
    if (newValue >= 1) {
      onChange(newValue);
    }
  };

  return (
    <TextField
      label="Level Number"
      type="number"
      value={value}
      onChange={handleChange}
      inputProps={{ min: 1 }}
      disabled={disabled}
      fullWidth
    />
  );
};
